// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';

export const addClaimToAudit = claim => ({
    itemToAdd: claim,
    type: actions.ADD_CLAIM_TO_TCSM_AUDIT
});

export const removeClaimFromAudit = claim => ({
    itemToRemove: claim,
    type: actions.REMOVE_CLAIM_FROM_TCSM_AUDIT
});



// WEBPACK FOOTER //
// ./src/tcsm/claim-search/action-creators/add-remove-claim.js